export default {"src":"/_next/static/media/redo.a66f5971.svg","height":16,"width":16};